import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import {
  ArrowLeft,
  Building2,
  Handshake,
  MessageCircle,
  Store,
} from "lucide-react";

const WHATSAPP_NUMBER = "526673093018";
const whatsappMessage =
  "Hola, tengo una propiedad y quiero saber si puede interesarle a una empresa o franquicia.";

const companies = [
  { name: "OXXO", logo: "/logos/logo12.png" },
  { name: "Farmacias Guadalajara", logo: "/logos/logo10.png" },
  { name: "Farmacias Similares", logo: "/logos/logo1.png" },
  { name: "Kiosko", logo: "/logos/logo4.png" },
];

const steps = [
  {
    title: "Revisamos tu propiedad",
    description:
      "Vemos ubicación, medidas, zona, accesos, fotos y condiciones generales para entender si puede ser candidata.",
    icon: Building2,
  },
  {
    title: "La acercamos al contacto correcto",
    description:
      "Si cumple con lo que busca alguna empresa, la hacemos llegar a encargados de expansión o responsables de crecimiento.",
    icon: Handshake,
  },
  {
    title: "Damos seguimiento",
    description:
      "Acompañamos el proceso para que el dueño sepa si hay interés, qué información falta y cuál podría ser el siguiente paso.",
    icon: Store,
  },
];

const ConQuienesColaboramos = () => {
  const navigate = useNavigate();
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <section className="mx-auto max-w-5xl">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="mb-6 inline-flex items-center gap-2 text-sm font-bold text-slate-600 transition hover:text-[#0056D2]"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver al inicio
          </button>

          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
            <p className="text-xs font-black uppercase tracking-wide text-[#F97316]">
              Contacto con empresas y franquicias
            </p>
            <h1 className="mt-3 max-w-3xl text-3xl font-black leading-tight text-slate-950 sm:text-4xl">
              Acercamos propiedades con potencial a empresas que buscan crecer.
            </h1>
            <p className="mt-4 max-w-3xl text-base leading-7 text-slate-600">
              Además de presentar tu propiedad de manera inteligente en nuestro
              portal, revisamos si tiene potencial para empresas o franquicias que
              buscan espacios para expansión. Si la propiedad cumple con los
              requisitos de alguna empresa, la hacemos llegar al contacto
              correspondiente y damos seguimiento.
            </p>
          </div>

          <div className="mt-6 rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="text-xs font-black uppercase tracking-wide text-slate-500">
                  Empresas de referencia
                </p>
                <h2 className="mt-2 text-xl font-black text-slate-950">
                  Cadenas con las que podemos revisar oportunidades
                </h2>
              </div>
            </div>

            <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {companies.map((company) => (
                <div
                  key={company.name}
                  className="flex min-h-28 items-center justify-center rounded-lg border border-slate-200 bg-slate-50 px-3 py-4 text-center"
                >
                  {company.logo ? (
                    <img
                      src={company.logo}
                      alt={company.name}
                      className="max-h-14 w-full object-contain"
                    />
                  ) : (
                    <span className="text-sm font-black text-slate-800">
                      {company.name}
                    </span>
                  )}
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs leading-5 text-slate-500">
              La revisión no garantiza aceptación. Cada empresa decide según sus
              propios requisitos de ubicación, medidas, zona, flujo y presupuesto.
            </p>
          </div>

          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {steps.map((item) => (
              <article
                key={item.title}
                className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-[#0056D2]">
                  <item.icon className="h-5 w-5" />
                </div>
                <h2 className="mt-4 text-lg font-black text-slate-950">
                  {item.title}
                </h2>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  {item.description}
                </p>
              </article>
            ))}
          </div>

          <div className="mt-6 rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm sm:p-8">
            <h2 className="text-xl font-black text-slate-950">
              ¿Quieres saber si tu propiedad puede aplicar?
            </h2>
            <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-slate-600">
              Escríbenos y te orientamos sobre este servicio de contacto con
              empresas y franquicias.
            </p>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center justify-center gap-2 rounded-lg bg-[#0056D2] px-5 py-3 text-sm font-black text-white transition hover:bg-blue-700"
            >
              <MessageCircle className="h-4 w-4" />
              Más información de este servicio
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ConQuienesColaboramos;
